<template>
  <header class="m_default-header">
    <v-icon v-if="leftIcon" class="left" @click="close">{{ leftIcon }}</v-icon>
    <v-icon v-else class="left" @click="close">mdi-close</v-icon>
    <h4>{{ title }}</h4>
    <v-icon class="right" @click="clickRightIcon">{{ rightIcon }}</v-icon>
  </header>
</template>

<script>
export default {
  name: "MobileHeader",
  props: {
    leftIcon: {
      type: String,
      default: String
    },
    title: {
      type: String,
      default: String
    },
    rightIcon: {
      type: String,
      default: String
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    clickRightIcon() {
      this.$emit("clickRightIcon");
    }
  }
};
</script>

<style></style>
